<ng-template #simpleTaskEditor let-config>
	<div *ngFor="let task of config.list; let i = index" class="border border-lightgrey rounded p-3 mb-2">
		<div class="d-flex">
			<div class="flex-weight-1 mr-2">
				<input class="form-control mb-2" placeholder="Task name" [(ngModel)]="task.name" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				<textarea rows="2" class="form-control" placeholder="Description" [(ngModel)]="task.description" [ngModelOptions]="{ standalone: true }"></textarea>
			</div>
			<button type="button" class="btn btn-outline-secondary btn-sm px-2 border-0 align-self-start" (click)="removeTask(config.list, i)" ngbTooltip="Remove task"><i class="wq wq-delete"></i></button>
		</div>
		<div class="d-flex flex-wrap align-items-center mt-2">
			<ui-checkbox-dropdown *ngIf="config.dependencies?.length" class="mr-3 mb-2" dropdownName="Dependencies" [items]="config.dependencies" [maxShown]="1" selectProp="id" [selectedItems]="task.dependencies" (selectionChange)="taskDependencyChange($event, task)"></ui-checkbox-dropdown>
			<select *ngIf="config.phases?.length" class="custom-select w-auto mr-3 mb-2" [(ngModel)]="task.phase_id" [ngModelOptions]="{ standalone: true }">
				<option [ngValue]="null">Select a phase</option>
				<option *ngFor="let p of config.phases" [ngValue]="p.id">{{p.name}}</option>
			</select>
		</div>
		<div class="d-flex flex-wrap align-items-center">
			<input class="form-control w-5r d-inline-block mr-1" [(ngModel)]="task.duration" (change)="taskDurationChanged(task)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
			<select class="custom-select w-auto mr-3" [(ngModel)]="task.duration_type" [ngModelOptions]="{ standalone: true }">
				<option value="min">mins</option>
				<option value="hour">hours</option>
			</select>
			<label class="custom-control custom-checkbox">
				<input type="checkbox" class="custom-control-input" [ngModel]="!!task.billable" (ngModelChange)="task.billable = $event ? 1 : 0" [ngModelOptions]="{ standalone: true }">
				<span class="custom-control-label">Billable?</span>
			</label>
		</div>
	</div>
	<button *ngIf="config.showAdd" type="button" class="btn btn-outline-secondary btn-sm mt-2" (click)="addTask(config.list)"><i class="wq wq-add mr-1"></i> Add task</button>
</ng-template>

<form>
	<ui-modal [modalTitle]="id === 'new' ? 'New Job' : 'Job Details'" size="md" [scrollable]="true">
		<div *ngIf="details?.record" ui-modal-header>
			<div class="dropdown dropdown-light d-inline-block mr-2">
				<button type="button" class="btn btn-outline-secondary border-0 p-2 mr-2 dropdown-toggle" data-toggle="dropdown"><i class="wq wq-more"></i></button>
				<div class="dropdown-menu dropdown-menu-right border-primary">
					<button type="button" class="dropdown-item" (click)="saveAsTemplate()">Save as job template</button>
				</div>
			</div>
		</div>

		<ng-container *ngIf="details?.record">
			<ui-form labelWidth="10rem">

				<ui-form-control label="Project" *ngIf="project_id === null">
					<div class="d-flex">
						<input class="form-control" [(ngModel)]="details.record.project" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off" readonly>
						<button *ngIf="id === 'new'" type="button" class="btn btn-outline-secondary p-2 ml-1" (click)="projectSelectModal.open({})"><i class="wq wq-search"></i></button>
					</div>
				</ui-form-control>

				<ui-form-control label="Job Name">
					<input type="text" class="form-control" [(ngModel)]="details.record.name" autocomplete="chrome-off" [ngModelOptions]="{standalone: true}">
				</ui-form-control>

				<ui-form-control label="Type">
					<select class="custom-select" [(ngModel)]="details?.record['type']" [disabled]="mode === 'book'" [ngModelOptions]="{standalone: true}">
						<option value="contract">Contract</option>
						<option value="sales">Sales</option>
						<option value="service">Service</option>
					</select>
				</ui-form-control>

				<ui-form-control>
					<label class="custom-control custom-checkbox d-inline-block">
						<input type="checkbox" class="custom-control-input" [ngModelOptions]="{ standalone: true }" [(ngModel)]="billable" [disabled]="details.record.stage === 'completed' || mode === 'book'">
						<span class="custom-control-label">Billable</span>
					</label>
				</ui-form-control>

				<ui-form-control label="Label" *ngIf="details?.label_list?.length">
					<div #multiselectdropdown class="multi-select">
						<div class="selected-labels custom-select" (click)="toggleDropdown()">
							<span class="selectable mr-3" *ngFor="let labelData of selectedLabels">
								<ui-label class="selectable" [label_text]="labelData.text" [label_color]="labelData.label_color" (click)="toggleSelection(labelData);$event.stopPropagation();"></ui-label>
							</span>
						</div>
						<div class="dropdown">
							<div class="dropdown-menu shadow-sm bg-white border-lightgrey" [ngClass]="{ 'show': isDropdownOpen }">
								<ng-container *ngFor="let labelData of labelList">
									<div class="selectable hoverable rounded p-1" (click)="toggleSelection(labelData);$event.stopPropagation();">
										<ui-label [label_text]="labelData.text" [label_color]="labelData.label_color"></ui-label>
									</div>
								</ng-container>
								<div *ngIf="!labelList.length" class="text-secondary p-1">No more labels.</div>
							</div>
						</div>
					</div>
				</ui-form-control>

				<ui-form-control label="Notes">
					<textarea class="form-control" rows="3" [(ngModel)]="details?.record.notes" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off" [disabled]="details.record.stage === 'completed' || mode === 'book'"></textarea>
				</ui-form-control>

				<ui-form-control>
					<label class="custom-control custom-checkbox d-inline-block">
						<input type="checkbox" class="custom-control-input" [ngModelOptions]="{ standalone: true }" [(ngModel)]="auto_complete" [disabled]="details.record.stage === 'completed' || mode === 'book'">
						<span class="custom-control-label">Autocomplete Job</span>
					</label>
					<div class="text-info"><i class="wq wq-info mr-1"></i>Marks Job as complete automatically when all its tasks are completed</div>
				</ui-form-control>

				<hr>
				<div class="d-flex mb-3">
					<h3 class="flex-weight-1">Job Location</h3>
					<div *ngIf="addresses?.length && hasAddress">
						<button type="button" class="btn" [ngClass]="hasMatchingAddress ? 'btn-success' : 'btn-outline-success'"
							(click)="openAddressPicker()">
							{{details.record.address_name ? details.record.address_name : 'Use Existing Address'}}
						</button>
					</div>
				</div>
				<ui-form-control label="Address">
					<input type="text" class="form-control" [(ngModel)]="details.record.address_line_1" autocomplete="chrome-off" [ngModelOptions]="{standalone: true}">
				</ui-form-control>
				<ui-form-control label="">
					<input type="text" class="form-control" [(ngModel)]="details.record.address_line_2" autocomplete="chrome-off" [ngModelOptions]="{standalone: true}">
				</ui-form-control>
				<ui-form-control label="">
					<input type="text" class="form-control" [(ngModel)]="details.record.address_line_3" autocomplete="chrome-off" [ngModelOptions]="{standalone: true}">
				</ui-form-control>
				<ui-form-control label="Town / City">
					<input type="text" class="form-control" [(ngModel)]="details.record.posttown" autocomplete="chrome-off" [ngModelOptions]="{standalone: true}">
				</ui-form-control>
				<ui-form-control label="County / State">
					<input type="text" class="form-control" [(ngModel)]="details.record.county" autocomplete="chrome-off" [ngModelOptions]="{standalone: true}">
				</ui-form-control>
				<ui-form-control label="Postcode / ZIP">
					<input type="text" class="form-control" [(ngModel)]="details.record.postcode" autocomplete="chrome-off" [ngModelOptions]="{standalone: true}">
				</ui-form-control>
				<ui-form-control label="Country">
					<input type="text" class="form-control" [(ngModel)]="details.record.country" autocomplete="chrome-off" [ngModelOptions]="{standalone: true}">
				</ui-form-control>

				<ng-container *ngIf="id === 'new'">
					<hr>
					<h3 class="mb-3">Tasks</h3>
					<ng-container *ngTemplateOutlet="simpleTaskEditor; context: { $implicit: { list: details.record.tasks, showAdd: true, phases: details.phases, dependencies: details.dependencies } }"></ng-container>
				</ng-container>
			</ui-form>
		</ng-container>

		<button *ngIf="id !== 'new' && mode !== 'book' && !details?.record.is_default" type="button" class="btn btn-danger" (click)="delete()" [disabled]="disabled" ui-modal-footer>Delete</button>
		<button *ngIf="details?.record.stage === 'completed'" type="button" class="btn btn-primary" (click)="reopen()" [disabled]="disabled" ui-modal-footer>Reopen </button>
		<div class="flex-weight-1" ui-modal-footer></div>
		<button type="button" class="btn btn-secondary" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button type="button" class="btn btn-primary" (click)="saveButton()" [disabled]="disabled" ui-modal-footer>Save</button>
	</ui-modal>
</form>

<ui-modal modalTitle="Create new job" size="sm" [scrollable]="true" [footer]="false" #selectJobTemplateModal>
	<ng-container *ngIf="jobTemplates">
		<div>Create from scratch:</div>
		<div class="d-flex flex-column">
			<button class="btn btn-outline-secondary mt-2" (click)="loadNew()" [disabled]="disabled">New Job</button>
		</div>
		<ng-container *ngIf="jobTemplates.length">
			<div class="mt-3">Create from template:</div>
			<div class="d-flex flex-column">
				<div *ngFor="let t of jobTemplates" class="btn-group">
					<button class="btn btn-outline-secondary mt-2" (click)="selectTemplate(t)" [disabled]="disabled">{{t.template_name}}</button>
					<button class="btn btn-outline-secondary mt-2 flex-weight-0 px-2" (click)="editTemplate(t)" ngbTooltip="Edit Template" [disabled]="disabled"><i class="wq wq-edit"></i></button>
					<button class="btn btn-outline-secondary mt-2 flex-weight-0 px-2" (click)="deleteTemplate(t)" ngbTooltip="Delete Template" [disabled]="disabled"><i class="wq wq-delete"></i></button>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ui-modal>

<form>
	<ui-modal [modalTitle]="editingTemplateId ? 'Edit Job Template' : 'Save as Job Template'" size="md" [scrollable]="true" #saveAsJobTemplateModal>
		<ui-form *ngIf="saveAsJobTemplateModal.isOpen" direction="vertical">
			<ui-form-control label="Template Name">
				<input class="form-control" [(ngModel)]="templateName" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off" appDesktopFocus>
			</ui-form-control>

			<ng-container *ngIf="editingTemplateId">
				<ui-form-control label="Job Name">
					<input type="text" class="form-control" [(ngModel)]="templateData.name" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="Type">
					<select class="custom-select" [(ngModel)]="templateData.type" [ngModelOptions]="{ standalone: true }">
						<option value="contract">Contract</option>
						<option value="sales">Sales</option>
						<option value="service">Service</option>
					</select>
				</ui-form-control>
				<ui-form-control>
					<label class="custom-control custom-checkbox d-inline-block">
						<input type="checkbox" class="custom-control-input" [ngModel]="!!templateData.billable" (ngModelChange)="templateData.billable = $event ? 1 : 0" [ngModelOptions]="{ standalone: true }">
						<span class="custom-control-label">Billable</span>
					</label>
				</ui-form-control>
				<ui-form-control label="Notes">
					<textarea class="form-control" rows="3" [(ngModel)]="templateData.notes" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off"></textarea>
				</ui-form-control>
				<ui-form-control label="Address">
					<input type="text" class="form-control" [(ngModel)]="templateData.address_line_1" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="">
					<input type="text" class="form-control" [(ngModel)]="templateData.address_line_2" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="">
					<input type="text" class="form-control" [(ngModel)]="templateData.address_line_3" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="Town / City">
					<input type="text" class="form-control" [(ngModel)]="templateData.posttown" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="County / State">
					<input type="text" class="form-control" [(ngModel)]="templateData.county" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="Postcode / ZIP">
					<input type="text" class="form-control" [(ngModel)]="templateData.postcode" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="Country">
					<input type="text" class="form-control" [(ngModel)]="templateData.country" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
			</ng-container>

			<ui-form-control *ngIf="templateTasks.length || id !== 'new' || editingTemplateId" label="Tasks">
				<ng-container *ngTemplateOutlet="simpleTaskEditor; context: { $implicit: { list: templateTasks, showAdd: id !== 'new' || editingTemplateId, phases: templatePhases, dependencies: templateDependencies } }"></ng-container>
			</ui-form-control>
		</ui-form>

		<button type="button" class="btn btn-secondary" (click)="saveAsJobTemplateModal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button type="submit" class="btn btn-primary" (click)="saveJobTemplate()" [disabled]="disabled" ui-modal-footer>Save</button>
	</ui-modal>
</form>

<app-modal-select-project (close)="projectSelectModalClosed($event)"></app-modal-select-project>
<app-modal-select-address (close)="addressPickerClosed($event)"></app-modal-select-address>
